import * as AT from '../constants/actionTypes'

/**
 * Add new daily opener and resort list.
 * @param {*} state 
 * @param {*} newDailyOpener 
 */
function generateNewDailyOpenerList(state, newDailyOpener) {
	let temp = [ newDailyOpener, ...state.dailyOpenerList.filter( x => !(x.day === newDailyOpener.day && x.visitorname === newDailyOpener.visitorname)) ];	
	temp = temp.sort((a,b) => b.day.localeCompare(a.day));
	return temp;
}

/**
 * Daily opener reducer
 * @param {*} state 
 * @param {*} action 
 */
function dailyOpener(state = { dailyOpenerList: [] }, action) {
	switch (action.type) {
		case AT.DAILYOPENER_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				success: undefined,
				isLoading: true,
				dailyOpenerList: [],
				error: undefined
			})
		case AT.DAILYOPENER_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.DAILYOPENER_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				dailyOpenerList: action.payload.dailyOpeners,
				error: undefined
			})	
		case AT.DAILYOPENER_SAVING_STARTED:
			return Object.assign({}, state, {
				success: undefined,
				isSaving: true,
				error: undefined
			})
		case AT.DAILYOPENER_SAVING_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.DAILYOPENER_SAVING_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				dailyOpenerList: generateNewDailyOpenerList(state, action.payload.newDailyOpener),
				success: 'Sikeres kilométeróra napi állás mentés.',
				error: undefined
			})						
		default:
			return state;
	}
}

export default dailyOpener;